<template>
    <div class="hero"  :class="done"  v-on:mouseover="res">
      <media-type v-if="!isMobile" :className="'hero-culture-media-type'" :obj="cultureData.media" :dynAlt="'NOSSA Cultura'"></media-type>
      <media-type v-if="isMobile" :className="'hero-culture-media-type'" :obj="cultureData.media_mob" :dynAlt="'NOSSA Cultura'"></media-type>


      <div class="main-headline">

        <div class="master-headline">
          <h1 class="head-line-white" v-html="cultureData.white[lang].name"></h1>
          <h1 class="head-line-orange" v-html="cultureData.orange[lang].name"></h1>


        </div>

      </div>

      <div class="reel-bt" v-on:click="playVid()" >
        <span v-if="lang === 0">VER FILME COMPLETO</span>
        <span v-if="lang === 1">SEE FULL MOVIE</span>

      </div>


      <div class="reel" :class="vis" >
        <video id="vid" playsinline >
          <source :src="cultureData.reel" type="video/webm">
          <source :src="cultureData.reel_2" type="video/mp4">
        </video>

        <div class="controls" v-if="!isMobile">
          <img src="/static/images/pause.png" v-on:click="pauseVid()" alt="">
          <img src="/static/images/volume-adjustment.png" v-on:click="muteVid()"  v-if="vol == 1" alt="">
          <img src="/static/images/mute.png" v-on:click="unmuteVid()"  v-if="vol == 0" alt="">

        </div>
      </div>

      <media-type v-if="isMobile" :className="'viemo-people'" :obj="relMob" :dynAlt="'NOSSA Cultura'"></media-type>



    </div>
</template>

<script>



    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, WP} from '../../main';
    import MediaType from "./MediaType";


    export default {
        name: 'hero-culture',
      components: {MediaType},
      props: ['lang', 'cultureData', 'incPagePos', 'isMobile'],
      watch: {
        'incPagePos': function () {

        //  this.reposText(this.incPagePos);

        }
      },

        data() {
            return {
                actScreen: 0,
              done: '',
              vid : {},
              vis: '',
              vol: 1,
              relMob:{
                type : 'viemo',
                viemo : '685845301'
              }
            }
        },

        created() {




          console.log()



        },
        mounted() {

            //EVENTBUS.$on('AAA', AAA);
            //EVENTBUS.$emit('AAA', 0);

        //  TweenMax.to( '.master-headline', 1, {delay:0.5, x: 0 , force3D: true, ease: "circ.out"} );


         // TweenMax.to( '.hero', 1, {className:"+=done ", force3D: true, ease: "circ.out"} );

        //  this.init();

          const _this = this;

          setTimeout(function(){
            _this.done = 'done';

            TweenMax.to( '.head-line-orange', 1, { delay: 1, x: 0 , force3D: true, ease: Back.easeOut.config(1.4)} );
            TweenMax.to( '.head-line-white', 1, { delay: 1, x: 0 , force3D: true, ease: Back.easeOut.config(1.4)} );

          }, 100);
          this.vid =  document.getElementById("vid");
          EVENTBUS.$on('pauseVid', this.pauseVid);
        },

        destroyed() {

        },

        methods: {
          res(){
           // EVENTBUS.$emit('resetTeam');
          },

            init() {


             // TweenMax.to( '.sub-headline', 1, { x: '-60%' , force3D: true, ease:Back.easeOut.config(1.4)} );

            },

          playVid() {


            if(window.innerWidth < 800){

              window.open('https://vimeo.com/756412300', '_blank');
            }else{

              this.vid.play();
              this.vis = 'vis';
              this.vid.addEventListener('ended',function(){

                EVENTBUS.$emit('pauseVid');

              },false);
            }

          },

          pauseVid() {

            this.vid.pause();
            this.vis = '';
            this.vid.currentTime = 0;

          },

          muteVid(){
            this.vol = 0;
            this.vid.volume = this.vol;
          },

          unmuteVid(){
            this.vol = 1;
            this.vid.volume = this.vol;
          },
          reposText(n){

              let pos1 =  80 - (n * 0.4);
              let pos2 =  -110 + (n * 0.4);

              if(pos1 <= 0){
                pos1 = 0;
              }


            if(pos2 >= 0){
              pos2 = 0;
            }

              console.log(pos2)

            TweenMax.to( '.master-headline', 1, { x: pos1 +'%' , force3D: true, ease: "circ.out"} );
            TweenMax.to( '.sub-headline', 1, { x: pos2 +'%' , force3D: true, ease: "circ.out"} );

          },


        },
    };

</script>











// WEBPACK FOOTER //
// src/components/Modules/HeroCulture.vue